import { LockIcon } from '@tlx/atlas';
import { FormattedMessage } from 'react-intl';
export function InsufficientAccessPage() {
    return (
        <div>
            <h1 className={'menu-header'}>
                <FormattedMessage id={'text_site_login_insufficient_access'} />
            </h1>
            <div className={'align-center'}>
                <div className={'blue-circle'}>
                    <LockIcon className={'insufficient-access-page-icon'} />
                </div>
            </div>
            <h1 className={'insufficient-access-page-title'}>
                <FormattedMessage id={'text_site_login_insufficient_access'} />
            </h1>
            <p className={'insufficient-access-page-text'}>
                <FormattedMessage id={'text_access_denied_object'} />
            </p>
        </div>
    );
}
